import { render, staticRenderFns } from "./ModalCreate.vue?vue&type=template&id=66732476"
import script from "./ModalCreate.vue?vue&type=script&lang=js"
export * from "./ModalCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports